import { BaseServiceDao } from "@/data/dao/service/BaseServiceDao";

import { daoServicesList } from "./DaoServicesList";
import { FallbackCookieCache } from "./offline/FallbackCookieCache";

export class Factory {
    private static instances = {};

    static getInstance<T>(classType: any): T {
        if (classType["getClassName"] === undefined)
            throw new Error("Class " + classType + " does not implement getClassName()");

        const classIdentifier = classType["getClassName"]();
        if (classIdentifier === undefined || classIdentifier == null)
            throw new Error("Class " + classType + " does not implement getClassName()");

        // check if instance existists
        const instance = this.instances[classIdentifier];
        if (instance !== undefined) return instance;

        if (classIdentifier === "OfflineCache") {
            this.instances[classIdentifier] = new FallbackCookieCache();
        } else {
            this.instances[classIdentifier] = new daoServicesList[classIdentifier]();
        }

        return this.instances[classIdentifier];
    }

    public static eachInstance(handler: { (inst: BaseServiceDao) }) {
        for (const i in Factory.instances) {
            handler(Factory.instances[i]);
        }
    }
}
